import { useStaticQuery } from "gatsby";
var useCmsEditionAndCategory = function useCmsEditionAndCategory() {
    var data = useStaticQuery("1810303247");
    return data;
};
export default useCmsEditionAndCategory;
